const mapConfig = {
  dataCollection: 'stations-v3',
  settingsCollection: 'settings-v3'
}

export default mapConfig;